module.exports = __webpack_public_path__ + "static/media/Kalimati.9ca517a7.woff";